export const isUrl = (value: string) => {
  return /^(https?:\/\/)?([\w.-]+)\.[a-z]{2,}(:\d+)?(\/.*)?$/i.test(value)
}
